/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
import { percentStringHelper } from 'embercom/lib/percentage-formatter';

export default buildHelper(function (params) {
  return percentStringHelper(params);
});
